import {Pipe, PipeTransform} from "@angular/core";
import {DomSanitizer, SafeHtml} from "@angular/platform-browser";

@Pipe({
  name: 'sanitizeHtml'
})
export class SanitizeHtmlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {
  }

  transform(value: string): SafeHtml {
    if (typeof value === 'string') {
      return this.sanitizer.bypassSecurityTrustHtml(value);
    }

    return value;
  }
}



// WEBPACK FOOTER //
// ./src/pipes/sanitize-html.pipe.ts